import React from 'react';

export default function Show() {
  return <div><p>Clinical Review Show - coming soon</p></div>;
}
